export default __webpack_public_path__ + "static/ams-17b9b6b5a8991347b56e545bccb0f8a4.png";